// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"_93444fe79c--fullscreen--mfCte","no-print":"_93444fe79c--no-print--WH57H"};